exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hyperlink-color[data-v-6cf5ce9c]{color:#3b9bf0}[data-v-6cf5ce9c] .ql-container.ql-snow{border:none}[data-v-6cf5ce9c] .ql-align-center img{display:inline-block}", ""]);

// exports
